const initialState = {
  id: "infotext-leftpanel",
  title: "",
  isOpen: false,
  setIsOpen: () => {},
  content: "",
  backUrl: "",
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "LEFTPANEL_UPDATE":
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
}
